import React, { useEffect, useState } from "react";
import "../../Styles/Profle/SideBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { NavLink, useNavigate } from "react-router-dom";
import api from "../../api";

function SideBar() {
  const [isActive, setIsActive] = useState(false);
  const [profile, setProfile] = useState('');
    const navigate = useNavigate();
  

  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {

    try {
      const response = await api.get(
        `/user_api/get-user-details?access_token=${JSON.parse(accessToken)}`,
      );
      setProfile(response.data.user_details[0]);
    } catch (error) {
      console.log('Error fetching profile:', error.response);
    }
  };
  const handleLogout = async () => {
    try {
      localStorage.removeItem('accessToken');

      navigate("/login");
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="SideBar_div">
      <div className="Profile_Sidebar_header shadow" 
      style={{height: "60px", }}
      >
        <div className="Profile_Sidebar_header_img">
          <p className="Profile_Sidebar_header_name">Hello!</p>
          <p className="Profile_Sidebar_header_name">Members</p>
        </div>

        {/* <div className="Profile_completion">
          <p className="Profile_completion_name">Profile Completion</p>
          <span className="Profile_completion_num">20%</span>
        </div> */}
        
       
      </div>
      <div className="order_return_div shadow">
        <NavLink className="Profile_Order_div" to="/profile/myorders">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/orders-icon.svg" />
          </span>
          <span>Orders</span>
        </NavLink>
        {/* <NavLink className="Profile_Order_div" to="/profile/returns">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/returns-icon.svg" />
          </span>
          <span>Returns</span>
        </NavLink> */}
        {/* <NavLink className="Profile_Order_div" to="/profile/esooq-credits">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/noon-credit-icon.svg" />
          </span>
          <span>Esooq Credits</span>
        </NavLink> */}
        {/* <NavLink className='Profile_Order_div'to="/profile/wishlist"><span className='icon_img'><img src='https://f.nooncdn.com/s/app/com/noon/icons/mobile/account-wishlist-v2.svg' /></span><span>Wishlist</span></NavLink> */}
      </div>
      <div className="My_account">
        <div>MY ACCOUNT</div>
      </div>
      <div className="order_return_div shadow">
        <NavLink to="/profile" className="Profile_Order_div">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/profile-icon.svg" />
          </span>
          <span>Profile</span>
        </NavLink>
        {/* <NavLink className="Profile_Order_div" to="/profile/address">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/address-icon.svg" />
          </span>
          <span>Address</span>
        </NavLink> */}
        {/* <NavLink className="Profile_Order_div" to="/profile/payments">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/payments-icon.svg" />
          </span>
          <span>Payments</span>
        </NavLink> */}
        {/* <NavLink className="Profile_Order_div" to="/profile/warranty-claim">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/warranty-claims-icon.svg" />
          </span>
          <span>Warranty Claims</span>
        </NavLink> */}
      </div>
      <div className="My_account">
        <div>OTHERS</div>
      </div>
      
      <div className="order_return_div shadow">
        <NavLink className="Profile_Order_div" to="/profile/settings">
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/icons/security-settings.svg" />
          </span>
          <span>Security Settings</span>
        </NavLink>
      </div>
      <div className="order_return_div shadow" onClick={handleLogout}>
        <NavLink
          id="Sign_out"
          className="Profile_Order_div"
          
        >
          <span className="icon_img">
            <img src="https://f.nooncdn.com/s/app/com/noon/design-system/creative-icons/account-sign-out.svg" />
          </span>
          <span style={{color:"red"}}>Sign Out</span>
        </NavLink>
      </div>
    </div>
  );
}

export default SideBar;
